document.addEventListener('DOMContentLoaded', function() {
    var sliderContainer = document.querySelector('.features__slider');
    if (!sliderContainer) return; // Jeśli slider nie istnieje, zakończ skrypt
    var prevButton = sliderContainer.querySelector('.prev');
    var nextButton = sliderContainer.querySelector('.next');
    var contentContainers = document.querySelectorAll('.features__container');
    var numberIndicators = sliderContainer.querySelectorAll('.number');
    var totalTabs = contentContainers.length;
    var currentTab = 1;
    function updateSlider(newTab) {
        currentTab = newTab;
        // Aktualizacja kontenerów z treścią
        contentContainers.forEach(function(container) {
            if (container.dataset.tabContent === String(currentTab)) {
                container.classList.add('active');
                container.classList.remove('passive');
            } else {
                container.classList.remove('active');
                container.classList.add('passive');
            }
        });
        // Aktualizacja wskaźników numerów
        numberIndicators.forEach(function(number) {
            if (number.dataset.tabContent === String(currentTab)) {
                number.classList.add('active');
                number.classList.remove('passive');
            } else {
                number.classList.remove('active');
                number.classList.add('passive');
            }
        });
    }
    prevButton.addEventListener('click', function() {
        var newTab = currentTab === 1 ? totalTabs : currentTab - 1;
        updateSlider(newTab);
    });
    nextButton.addEventListener('click', function() {
        var newTab = currentTab === totalTabs ? 1 : currentTab + 1;
        updateSlider(newTab);
    });
});

//# sourceMappingURL=Kickstarter.f52143f1.js.map
